/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { _ as _slicedToArray } from '../_chunks/dep-dcf624da.mjs';
import { defineComponent, toRefs, ref, computed, nextTick, watch, onMounted, withDirectives, createVNode, resolveDirective, Fragment, mergeProps } from 'vue';
import props from './props.mjs';
import './utils/index.mjs';
import setStyle from '../_common/js/utils/set-style.mjs';
import TransferDom from '../utils/transfer-dom.mjs';
import { isFixed, getWindowScroll, removeClass, addClass } from '../utils/dom.mjs';
import useVModel from '../hooks/useVModel.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import { Button } from '../button/index.mjs';
import { Popup } from '../popup/index.mjs';
import getRelativePosition from './utils/getRelativePosition.mjs';
import getTargetElm from './utils/getTargetElm.mjs';
import { scrollToParentVisibleArea } from './utils/getScrollParent.mjs';
import scrollToElm from './utils/scrollToElm.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../utils/easing.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../utils/render-tnode.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';
import '../button/button.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../loading/props.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';
import '../button/props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../utils/set-style.mjs';
import '../form/hooks.mjs';
import '../button/type.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../popup/props.mjs';
import '../popup/container.mjs';
import '../popup/type.mjs';

var _Guide = defineComponent({
  name: "TGuide",
  directives: {
    TransferDom: TransferDom
  },
  props: props,
  setup: function setup(props2) {
    var renderTNodeJSX = useTNodeJSX();
    var COMPONENT_NAME = usePrefixClass("guide");
    var LOCK_CLASS = usePrefixClass("guide--lock");

    var _toRefs = toRefs(props2),
        current = _toRefs.current,
        modelValue = _toRefs.modelValue,
        hideCounter = _toRefs.hideCounter,
        hidePrev = _toRefs.hidePrev,
        hideSkip = _toRefs.hideSkip,
        steps = _toRefs.steps,
        zIndex = _toRefs.zIndex;

    var _useVModel = useVModel(current, modelValue, props2.defaultCurrent, props2.onChange, "current"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerCurrent = _useVModel2[0],
        setInnerCurrent = _useVModel2[1];

    var overlayLayerRef = ref();
    var highlightLayerRef = ref();
    var referenceLayerRef = ref();
    var currentHighlightLayerElm = ref();
    var nextHighlightLayerElm = ref();
    var dialogWrapperRef = ref();
    var dialogTooltipRef = ref();
    var actived = ref(false);
    var stepsTotal = computed(function () {
      return steps.value.length;
    });
    var currentStepInfo = computed(function () {
      return steps.value[innerCurrent.value];
    });
    var isPopup = computed(function () {
      return getCurrentCrossProps("mode") === "popup";
    });
    var currentElmIsFixed = computed(function () {
      return isFixed(currentHighlightLayerElm.value || document.body);
    });

    var getCurrentCrossProps = function getCurrentCrossProps(propsName) {
      var _currentStepInfo$valu;

      return (_currentStepInfo$valu = currentStepInfo.value[propsName]) !== null && _currentStepInfo$valu !== void 0 ? _currentStepInfo$valu : props2[propsName];
    };

    var setHighlightLayerPosition = function setHighlightLayerPosition(highlighLayer) {
      var _getRelativePosition = getRelativePosition(nextHighlightLayerElm.value, currentHighlightLayerElm.value),
          top = _getRelativePosition.top,
          left = _getRelativePosition.left;

      var _nextHighlightLayerEl = nextHighlightLayerElm.value.getBoundingClientRect(),
          width = _nextHighlightLayerEl.width,
          height = _nextHighlightLayerEl.height;

      var highlightPadding = getCurrentCrossProps("highlightPadding");

      if (isPopup.value) {
        width += highlightPadding * 2;
        height += highlightPadding * 2;
        top -= highlightPadding;
        left -= highlightPadding;
      } else {
        var _getWindowScroll = getWindowScroll(),
            scrollTop = _getWindowScroll.scrollTop,
            scrollLeft = _getWindowScroll.scrollLeft;

        top += scrollTop;
        left += scrollLeft;
      }

      setStyle(highlighLayer, {
        width: "".concat(width, "px"),
        height: "".concat(height, "px"),
        top: "".concat(top, "px"),
        left: "".concat(left, "px")
      });
    };

    var showPopupGuide = function showPopupGuide() {
      var currentElement = getTargetElm(currentStepInfo.value.element);
      nextHighlightLayerElm.value = currentElement;
      nextTick(function () {
        scrollToParentVisibleArea(nextHighlightLayerElm.value);
        setHighlightLayerPosition(highlightLayerRef.value);
        setHighlightLayerPosition(referenceLayerRef.value);
        scrollToElm(nextHighlightLayerElm.value);
        currentHighlightLayerElm.value = currentElement;
      });
    };

    var destroyTooltipElm = function destroyTooltipElm() {
      var _referenceLayerRef$va;

      (_referenceLayerRef$va = referenceLayerRef.value) === null || _referenceLayerRef$va === void 0 ? void 0 : _referenceLayerRef$va.parentNode.removeChild(referenceLayerRef.value);
    };

    var showDialogGuide = function showDialogGuide() {
      nextTick(function () {
        var currentElement = dialogTooltipRef.value;
        nextHighlightLayerElm.value = currentElement;
        scrollToParentVisibleArea(nextHighlightLayerElm.value);
        setHighlightLayerPosition(highlightLayerRef.value);
        scrollToElm(nextHighlightLayerElm.value);
        currentHighlightLayerElm.value = currentElement;
      });
    };

    var destroyDialogTooltipElm = function destroyDialogTooltipElm() {
      var _dialogTooltipRef$val, _dialogWrapperRef$val;

      (_dialogTooltipRef$val = dialogTooltipRef.value) === null || _dialogTooltipRef$val === void 0 ? void 0 : _dialogTooltipRef$val.parentNode.removeChild(dialogTooltipRef.value);
      (_dialogWrapperRef$val = dialogWrapperRef.value) === null || _dialogWrapperRef$val === void 0 ? void 0 : _dialogWrapperRef$val.parentNode.removeChild(dialogWrapperRef.value);
    };

    var showGuide = function showGuide() {
      if (isPopup.value) {
        destroyDialogTooltipElm();
        showPopupGuide();
      } else {
        destroyTooltipElm();
        showDialogGuide();
      }
    };

    var destroyGuide = function destroyGuide() {
      var _highlightLayerRef$va, _overlayLayerRef$valu;

      destroyTooltipElm();
      destroyDialogTooltipElm();
      (_highlightLayerRef$va = highlightLayerRef.value) === null || _highlightLayerRef$va === void 0 ? void 0 : _highlightLayerRef$va.parentNode.removeChild(highlightLayerRef.value);
      (_overlayLayerRef$valu = overlayLayerRef.value) === null || _overlayLayerRef$valu === void 0 ? void 0 : _overlayLayerRef$valu.parentNode.removeChild(overlayLayerRef.value);
      removeClass(document.body, LOCK_CLASS.value);
    };

    var handleSkip = function handleSkip(e) {
      var _props2$onSkip;

      var total = stepsTotal.value;
      actived.value = false;
      setInnerCurrent(-1, {
        e: e,
        total: total
      });
      (_props2$onSkip = props2.onSkip) === null || _props2$onSkip === void 0 ? void 0 : _props2$onSkip.call(props2, {
        e: e,
        current: -1,
        total: total
      });
    };

    var handlePrev = function handlePrev(e) {
      var _props2$onPrevStepCli;

      var total = stepsTotal.value;
      setInnerCurrent(innerCurrent.value - 1, {
        e: e,
        total: total
      });
      (_props2$onPrevStepCli = props2.onPrevStepClick) === null || _props2$onPrevStepCli === void 0 ? void 0 : _props2$onPrevStepCli.call(props2, {
        e: e,
        prev: innerCurrent.value - 1,
        current: innerCurrent.value,
        total: total
      });
    };

    var handleNext = function handleNext(e) {
      var _props2$onNextStepCli;

      var total = stepsTotal.value;
      setInnerCurrent(innerCurrent.value + 1, {
        e: e,
        total: total
      });
      (_props2$onNextStepCli = props2.onNextStepClick) === null || _props2$onNextStepCli === void 0 ? void 0 : _props2$onNextStepCli.call(props2, {
        e: e,
        next: innerCurrent.value + 1,
        current: innerCurrent.value,
        total: total
      });
    };

    var handleFinish = function handleFinish(e) {
      var _props2$onFinish;

      var total = stepsTotal.value;
      actived.value = false;
      setInnerCurrent(-1, {
        e: e,
        total: total
      });
      (_props2$onFinish = props2.onFinish) === null || _props2$onFinish === void 0 ? void 0 : _props2$onFinish.call(props2, {
        e: e,
        current: -1,
        total: total
      });
    };

    var initGuide = function initGuide() {
      if (innerCurrent.value >= 0 && innerCurrent.value < steps.value.length) {
        if (!actived.value) {
          actived.value = true;
          addClass(document.body, LOCK_CLASS.value);
        }

        showGuide();
      }
    };

    watch(innerCurrent, function (val) {
      if (val >= 0 && val < steps.value.length) {
        initGuide();
      } else {
        actived.value = false;
        destroyGuide();
      }
    });
    onMounted(function () {
      initGuide();
    });
    return function () {
      var renderOverlayLayer = function renderOverlayLayer() {
        return withDirectives(createVNode("div", {
          "ref": overlayLayerRef,
          "class": "".concat(COMPONENT_NAME.value, "__overlay"),
          "style": {
            zIndex: zIndex.value - 2
          }
        }, null), [[resolveDirective("transfer-dom"), "body"]]);
      };

      var renderHighlightLayer = function renderHighlightLayer() {
        var style = {
          zIndex: zIndex.value - 1
        };
        var highlightClass = ["".concat(COMPONENT_NAME.value, "__highlight"), "".concat(COMPONENT_NAME.value, "__highlight--").concat(isPopup.value ? "popup" : "dialog"), "".concat(COMPONENT_NAME.value, "--").concat(currentElmIsFixed.value && isPopup.value ? "fixed" : "absolute")];
        var showOverlay = getCurrentCrossProps("showOverlay");
        var maskClass = ["".concat(COMPONENT_NAME.value, "__highlight--").concat(showOverlay ? "mask" : "nomask")];
        var highlightContent = currentStepInfo.value.highlightContent;
        var showHighlightContent = highlightContent && isPopup.value;
        return withDirectives(createVNode("div", {
          "ref": highlightLayerRef,
          "class": highlightClass.concat(showHighlightContent ? highlightClass : maskClass),
          "style": style
        }, [showHighlightContent && createVNode(highlightContent, {
          "class": highlightClass.concat(maskClass),
          "style": style
        }, null)]), [[resolveDirective("transfer-dom"), "body"]]);
      };

      var renderCounter = function renderCounter() {
        var popupSlotCounter = renderTNodeJSX("counter", {
          params: {
            total: stepsTotal.value,
            current: innerCurrent.value
          }
        });

        var popupDefaultCounter = createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "__counter")
        }, [popupSlotCounter || createVNode("span", null, [innerCurrent.value + 1, "/", stepsTotal.value])]);

        return createVNode(Fragment, null, [!hideCounter.value && popupDefaultCounter]);
      };

      var renderAction = function renderAction(mode) {
        var isLast = innerCurrent.value === stepsTotal.value - 1;
        var isFirst = innerCurrent.value === 0;
        var buttonSize = mode === "popup" ? "small" : "medium";
        return createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "__action")
        }, [!hideSkip.value && !isLast && createVNode(Button, mergeProps({
          "class": "".concat(COMPONENT_NAME.value, "__skip"),
          "theme": "default",
          "size": buttonSize,
          "variant": "base",
          "onClick": handleSkip
        }, getCurrentCrossProps("skipButtonProps")), null), !hidePrev.value && !isFirst && createVNode(Button, mergeProps({
          "class": "".concat(COMPONENT_NAME.value, "__prev"),
          "theme": "primary",
          "size": buttonSize,
          "variant": "base",
          "onClick": handlePrev
        }, getCurrentCrossProps("prevButtonProps")), null), !isLast && createVNode(Button, mergeProps({
          "class": "".concat(COMPONENT_NAME.value, "__next"),
          "theme": "primary",
          "size": buttonSize,
          "variant": "base",
          "onClick": handleNext
        }, getCurrentCrossProps("nextButtonProps")), null), isLast && createVNode(Button, mergeProps({
          "class": "".concat(COMPONENT_NAME.value, "__finish"),
          "theme": "primary",
          "size": buttonSize,
          "variant": "base",
          "onClick": handleFinish
        }, props2.finishButtonProps), null)]);
      };

      var renderTooltipBody = function renderTooltipBody() {
        var title = createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "__title")
        }, [currentStepInfo.value.title]);

        var descBody = currentStepInfo.value.body;
        var renderDesc;

        if (typeof descBody === "string") {
          renderDesc = descBody;
        } else {
          renderDesc = createVNode(descBody, null, null);
        }

        var desc = createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "__desc")
        }, [typeof descBody === "string" ? descBody : createVNode(descBody, null, null)]);

        return createVNode(Fragment, null, [title, desc]);
      };

      var renderPopupContent = function renderPopupContent() {
        var footerClasses = ["".concat(COMPONENT_NAME.value, "__footer"), "".concat(COMPONENT_NAME.value, "__footer--popup")];

        var action = createVNode("div", {
          "class": footerClasses
        }, [renderCounter(), renderAction("popup")]);

        return createVNode("div", {
          "class": "".concat(COMPONENT_NAME.value, "__tooltip")
        }, [renderTooltipBody(), action]);
      };

      var renderPopupGuide = function renderPopupGuide() {
        var content = currentStepInfo.value.content;
        var renderBody;

        if (content) {
          var contentProps = {
            handlePrev: handlePrev,
            handleNext: handleNext,
            handleSkip: handleSkip,
            handleFinish: handleFinish,
            current: innerCurrent.value,
            total: stepsTotal.value
          };

          renderBody = function renderBody() {
            return createVNode(content, contentProps, null);
          };
        } else {
          renderBody = renderPopupContent;
        }

        var classes = ["".concat(COMPONENT_NAME.value, "__reference"), "".concat(COMPONENT_NAME.value, "--").concat(currentElmIsFixed.value ? "fixed" : "absolute")];
        return createVNode(Popup, {
          "visible": true,
          "show-arrow": !content,
          "zIndex": zIndex.value,
          "overlayClassName": currentStepInfo.value.stepOverlayClass,
          "overlayInnerClassName": _defineProperty({}, "".concat(COMPONENT_NAME.value, "__popup--content"), !!content),
          "placement": currentStepInfo.value.placement
        }, {
          "default": function _default() {
            return [withDirectives(createVNode("div", {
              "ref": referenceLayerRef,
              "class": classes
            }, null), [[resolveDirective("transfer-dom"), "body"]])];
          },
          content: renderBody
        });
      };

      var renderDialogGuide = function renderDialogGuide() {
        var _ref3;

        var style = {
          zIndex: zIndex.value
        };
        var wrapperClasses = ["".concat(COMPONENT_NAME.value, "__wrapper"), _defineProperty({}, "".concat(COMPONENT_NAME.value, "__wrapper--center"), currentStepInfo.value.placement === "center")];
        var dialogClasses = ["".concat(COMPONENT_NAME.value, "__reference"), "".concat(COMPONENT_NAME.value, "--absolute"), "".concat(COMPONENT_NAME.value, "__dialog"), (_ref3 = {}, _defineProperty(_ref3, "".concat(COMPONENT_NAME.value, "__dialog--nomask"), !getCurrentCrossProps("showOverlay")), _defineProperty(_ref3, currentStepInfo.value.stepOverlayClass, !!currentStepInfo.value.stepOverlayClass), _ref3)];
        var footerClasses = ["".concat(COMPONENT_NAME.value, "__footer"), "".concat(COMPONENT_NAME.value, "__footer--popup")];
        return createVNode(Fragment, null, [withDirectives(createVNode("div", {
          "ref": dialogWrapperRef,
          "class": wrapperClasses,
          "style": style
        }, [createVNode("div", {
          "ref": dialogTooltipRef,
          "class": dialogClasses
        }, [renderTooltipBody(), createVNode("div", {
          "class": footerClasses
        }, [renderCounter(), renderAction("dialog")])])]), [[resolveDirective("transfer-dom"), "body"]])]);
      };

      var renderGuide = function renderGuide() {
        return createVNode(Fragment, null, [renderOverlayLayer(), renderHighlightLayer(), isPopup.value ? renderPopupGuide() : renderDialogGuide()]);
      };

      return createVNode(Fragment, null, [actived.value && renderGuide()]);
    };
  }
});

export { _Guide as default };
//# sourceMappingURL=guide.mjs.map
